<app-tab id="search-list">

  <dx-text-box stylingMode="filled" (onValueChanged)="searchGrid($event)" placeholder="Recherche...">
    <dxi-button name="icon" location="before"
                [options]="{type: 'text', icon: 'search', disabled: true, elementAttr : {class: 'poi-search-panel-btn' }}"></dxi-button>
    <dxi-button name="filter" location="after"
                [options]="{type: 'text', icon: 'filter', onClick: filterClick}"></dxi-button>
  </dx-text-box>

  <dx-toolbar class="poi-toolbar">
    <dxi-item
      location="after"
      widget="dxDropDownButton"
      [options]="{
					items: alignments,
					displayExpr: 'name',
					keyExpr: 'value',
					icon: 'add',
					stylingMode: 'text',
					showArrowIcon: false,
					onItemClick: startDraw,
					dropDownOptions: {width: 110}, hint: 'Ajouter'
				}">
    </dxi-item>
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon: 'activefolder', hint: 'Categories', onClick: showCategoriesPopup}">
    </dxi-item>
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon: groupToggleIcon, hint: 'Afficher/Cacher', onClick: groupsToggle}"></dxi-item>
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon: 'refresh', hint: 'Recharger', onClick: refreshGrid}"></dxi-item>
    <dxi-item location="after"
              widget="dxButton"
              locateInMenu="auto"
              [options]="{icon: 'search', hint: 'Recherche', onClick: toggleSearch}">
    </dxi-item>
  </dx-toolbar>

  <dx-data-grid
    [dataSource]="ds"
    [showBorders]="false"
    [showColumnLines]="true"
    [showRowLines]="true"
    [errorRowEnabled]="false"
    [showColumnHeaders]="false"
    [hoverStateEnabled]="true"
    [activeStateEnabled]="true"
    [remoteOperations]="{ grouping: false }"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onEditingStart)="onGridEditingStart($event)"
    (onInitNewRow)="onGridInitNewRow($event)"
    (onRowInserting)="onGridRowInserting($event)"
    (onRowInserted)="onGridRowInserted($event)"
    (onRowUpdating)="onGridRowUpdating($event)"
    (onRowUpdated)="onGridRowUpdated($event)"
    (onRowRemoved)="onGridRowRemoved($event)"
    (onRowClick)="onRowClick($event)"
    (onContentReady)="onGridContentReady($event)"
    [columnAutoWidth]="true">
    <dxo-grouping expandMode="rowClick" [autoExpandAll]="false"></dxo-grouping>
    <dxi-column dataField="name" dataType="string" alignment="left" cellTemplate="cellTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'cellTemplate'">
      <div class="flex flex-row w-full">
        <span [ngStyle]="{backgroundColor: cell.data.color, width: '4px', marginRight: '8px'}">&nbsp;</span>
        <div>
          <span class="text-gray-700 text-sm block font-normal uppercase mb-1">{{cell.data.name}}</span>
          <div>
            <div class="flex items-center text-xs text-gray-500">
            <span [ngSwitch]="cell.data.type">
              <p *ngSwitchCase="'POINT'"><ic-icon class="mr-1" height="16px" [icon]="pointIcon"
                                                  [inline]="true"></ic-icon> Place</p>
              <p *ngSwitchCase="'POLYGON'"><ic-icon class="mr-1" height="16px" [icon]="polygonIcon"
                                                    [inline]="true"></ic-icon> Zone</p>
            </span>
              <p class="px-1">•</p>
              <p>
                <ic-icon class="mr-1" height="16px" [icon]="folderIcon" [inline]="true"></ic-icon>
                {{cell.data.category}}</p>
            </div>
          </div>
        </div>

        <span class="self-center" style="margin-left: auto;">
          <dx-button icon="overflow" (onClick)="showContextMenu($event, cell)"></dx-button>
        </span>
      </div>
    </div>
    <dxi-column dataType="string"
                alignment="left"
                name="domain_name"
                dataField="domain_name"
                groupCellTemplate="domainGroupTemplate"
                cssClass="domain-group"
                [formItem]="{visible: false}"
                [visible]="false"></dxi-column>
    <app-map-sidebar-group-header *dxTemplate="let group of 'domainGroupTemplate'"
                                  [group]="group"></app-map-sidebar-group-header>

    <dxi-column dataType="string"
                alignment="left"
                name="business_unit_name"
                dataField="business_unit_name"
                groupCellTemplate="buGroupTemplate"
                [formItem]="{visible: false}"
                [visible]="false"></dxi-column>
    <app-map-sidebar-group-header *dxTemplate="let group of 'buGroupTemplate'"
                                  [group]="group"></app-map-sidebar-group-header>

    <dxi-column dataType="string"
                alignment="left"
                groupCellTemplate="groupTemplate"
                dataField="category"
                [formItem]="{visible: false}"
                [visible]="false"></dxi-column>
    <app-map-sidebar-group-header *dxTemplate="let group of 'groupTemplate'"
                                  [group]="group"></app-map-sidebar-group-header>

    <dxi-column
      caption="Domaine"
      dataField="domain_id"
      editCellTemplate="domainChooser"
      [visible]="false"
      [showInColumnChooser]="false">
      <div *dxTemplate="let cellInfo of 'domainChooser';">
        <app-user-domains-chooser (valueChange)="editSelectedDomainChange($event, cellInfo)"
                                  [id]="cellInfo.value"
                                  height="35px"></app-user-domains-chooser>
      </div>
      <dxi-validation-rule type="required" message="Le domaine est obligatoire"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Nom"
      dataField="name"
      [editorOptions]="{stylingMode: 'outlined', height: '32px'}"
      [visible]="false">
      <dxi-validation-rule type="required" message="Le nom est obligatoire"></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [min]="3" [max]="100"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Couleur"
      dataField="color"
      [visible]="false">
      <dxo-form-item editorType="dxColorBox"
                     [editorOptions]="{applyValueMode: 'instantly', stylingMode: 'outlined', height: '32px'}"></dxo-form-item>
      <dxi-validation-rule type="required" message="La couleur est obligatoire"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Categorie"
      dataField="category_id"
      [visible]="false">
      <dxo-form-item editorType="dxSelectBox"
                     [editorOptions]="{dataSource: catDsLookup,
                     displayExpr: 'name',
                     disabled: editSelectCategoryDisabled,
                      valueExpr:'id',
                      stylingMode: 'outlined',
                      height: '32px'}"></dxo-form-item>
    </dxi-column>

    <dxi-column
      dataField="geometry"
      [visible]="false"
      [formItem]="{visible: false}">
    </dxi-column>

    <dxo-summary>
      <dxi-group-item
        column="name"
        summaryType="count">
      </dxi-group-item>
    </dxo-summary>

    <dxo-editing mode="form">

      <dxo-form [showValidationSummary]="true" labelLocation="left" colCount="1">
        <dxi-item>
          <dxo-label location="top"></dxo-label>
          <div *dxTemplate>
            <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-2 text-sm" role="alert">
              <p>Dessiner sur la carte.</p>
            </div>
          </div>
        </dxi-item>

        <dxi-item dataField="name"></dxi-item>
        <dxi-item dataField="color"></dxi-item>
        <dxi-item dataField="domain_id"></dxi-item>
        <dxi-item dataField="category_id"></dxi-item>
      </dxo-form>

    </dxo-editing>
  </dx-data-grid>
  <dx-context-menu *ngIf="contextMenuVisible"
                   [items]="editMenu"
                   [(visible)]="contextMenuVisible"
                   (onItemClick)="editMenuClick($event)"
                   [position]="{ my: 'top left', at: 'bottom left' }"
                   [target]="contextMenuTarget"
                   [width]="100">
    <div class="text-gray-700 text-sm" *dxTemplate="let m of 'item'; let i = index">
      <span class="text-base dx-icon-{{m.icon}}"></span>
      <span class="ml-2">{{m.name}}</span>
    </div></dx-context-menu>
</app-tab>

<dx-popup
  width="70%"
  height="70%"
  class="poi-cat-popup"
  [showTitle]="true"
  [dragEnabled]="false"
  title="Categories"
  [(visible)]="catPopupVisible">
  <div *dxTemplate="let data of 'content'">
    <dx-data-grid
      [dataSource]="catDs"
      [showBorders]="false"
      [showRowLines]="true"
      [columnAutoWidth]="true">
      <dxo-editing mode="form"
                   [allowDeleting]="true"
                   [allowAdding]="true"
                   [allowUpdating]="true">
        <!--<dxo-popup
          [showTitle]="false"
          [width]="700"
          [height]="420">
        </dxo-popup>-->
      </dxo-editing>
      <dxi-column
        caption="ID"
        width="8%"
        dataField="id"
        sortOrder="desc"
        [allowEditing]="false"
        [formItem]="{visible: false}"
        dataType="number">
      </dxi-column>

      <dxi-column
        caption="Nom"
        width="auto"
        dataField="name">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>

      <dxi-column
        caption="Domaine"
        [allowEditing]="false"
        [formItem]="{visible: false}"
        dataField="domain_name">
      </dxi-column>

      <dxi-column
        caption="BU"
        [allowEditing]="false"
        [formItem]="{visible: false}"
        dataField="business_unit_name">
      </dxi-column>

      <dxi-column
        caption="Date création"
        [allowEditing]="false"
        [formItem]="{visible: false}"
        dataField="created_at"
        format="shortDateShortTime"
        dataType="date">
      </dxi-column>

      <dxi-column
        caption="Date modification"
        [allowEditing]="false"
        [formItem]="{visible: false}"
        dataField="updated_at"
        format="shortDateShortTime"
        dataType="date">
      </dxi-column>

      <dxi-column
        caption="Domaine"
        dataField="domain_id"
        editCellTemplate="domainChooser"
        [visible]="false"
        [showInColumnChooser]="false">
        <div *dxTemplate="let cellInfo of 'domainChooser';">
          <app-user-domains-chooser (valueChange)="cellInfo.setValue($event)"
                                    [id]="cellInfo.value"></app-user-domains-chooser>
        </div>
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>
</dx-popup>
